exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, ".img-wrapper-slide-show {\n  position: relative;\n  width: 947px;\n  height: 450px;\n  margin: 0 auto; }\n  .img-wrapper-slide-show > img {\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 50%;\n    -webkit-transform: translate3d(-50%, 0, 0);\n            transform: translate3d(-50%, 0, 0); }\n", ""]);


/*****************
 ** WEBPACK FOOTER
 ** /home/live/git/production/project_hagelstamlive/~/css-loader!/home/live/git/production/project_hagelstamlive/~/autoprefixer-loader!/home/live/git/production/project_hagelstamlive/~/sass-loader!./slide_show/scss/slide_show.scss
 ** module id = 63
 ** module chunks = 0
 **/